import React, { useState } from 'react';

const ProfileForm = ({ user }) => {
  // Set the value of the text box to the user's name (or any other user property you want)
  const [profileName, setProfileName] = useState(user?.name || '');

  const handleChange = (e) => {
    setProfileName(e.target.value);
  };

  return (
    <div>
      <label htmlFor="profileName">Profile Name</label>
      <input
        type="text"
        id="profileName"
        value={profileName}
        onChange={handleChange}
        placeholder="Enter profile name"
      />
    </div>
  );
};

export default ProfileForm;
